import { Course, CourseType, EnrollmentBy } from '../../../../../../../../db/courses/types';
import i18n, { i18nNS } from '../../../../../../../../i18n';

export function getJoinCourseMessage(course: Course | null) {
  if (!course) return '';

  if (course.courseType === CourseType.SYNCED) {
    return i18n.t(
      'look_for_the_invitation_email_from_acadly_in_your_inbox_of_the_email_account_in_which_you_get_emails_from_your_lms',
      { ns: i18nNS.POLL }
    );
  }

  if (course.enrollmentType === EnrollmentBy.INVITATION) {
    return i18n.t(
      'look_for_the_invitation_email_from_acadly_in_your_inbox_please_ask_the_instructor_about_the_email_address_they_used',
      { ns: i18nNS.POLL }
    );
  }

  return i18n.t('please_sign_up_for_acadly_using_your_institute_email_address_and_the_join_code_join_code', {
    ns: i18nNS.POLL,
    joinCode: course.joinCode,
  });
}
